export default __webpack_public_path__ + "e9b76763ac024da464fae86e9b69dcbf.png";